import React from 'react';
import DescriptionItem from './descriptionItem';
import {Link} from "react-router-dom";

const Description = ({ label, isLowContent = false, signUp }) => {
  return (
    <div className="row h-100 auth-page-description auth-right-section">
      {!isLowContent && signUp && <div className="custom-signup-page" /> }
      {!isLowContent &&
      <div className="col-md-6 offset-md-3 d-flex flex-column justify-content-between z-index-2">
        <div></div>

        <div className="row">
          <h2 className="font-regular font-roboto-regular mb-5">Skip the traffic with remote intelligence</h2>
          <h3 className="text-light-grey mb-5">What can you expect when you sign up for FastMap?</h3>
          <div>
            <DescriptionItem label="Reduce time in traffic"/>
            <DescriptionItem label="Win more projects"/>
            <DescriptionItem label="Increase margins"/>
            <DescriptionItem label="Reduce carbon footprint"/>
          </div>
        </div>
        <div className="row">
          <p className="text-medium-grey p mb-5">
            <span>©2021 All Rights Reserved. FastMap® is a registered trademark of FastMap Inc. </span>
            <Link to={{ pathname: 'https://www.fastmap.ai/legal/privacy'}} className={'link-underline'} target="_blank">Privacy Policy</Link>.
            <span> and </span>
            <Link to={{ pathname: 'https://www.fastmap.ai/legal/terms'}} className={'link-underline'} target="_blank">Terms</Link>
          </p>
        </div>
      </div>
      }
    </div>
  );
}

export default Description;
